const hamburger = document.getElementById('hamburger');
const mobileMenu = document.getElementById('mobile-menu');
const closeMenu = document.getElementById('close-menu');

if (hamburger && mobileMenu) {
  hamburger.addEventListener('click', () => {
    mobileMenu.classList.toggle('mobile-menu--active');
  });
}

if (closeMenu) {
  closeMenu.addEventListener('click', () => {
    mobileMenu.classList.remove('mobile-menu--active');
  });
}
